import { customLocalStorage, getQueryParam, parseQueryStrings } from "@crehana/utils";
import addMinutes from "date-fns/addMinutes";
export var getNextUrl = function getNextUrl() {
  var nextUrl = getQueryParam('next') || '';
  return nextUrl;
};
export var redirectWithQueryParams = function redirectWithQueryParams(url) {
  var queryParams = window.location.search;
  var nextUrl = getNextUrl();

  /**
   * We need to remove the `next` query param if it contains /registro-extra/
   * when we change to /entrar/ so we don't trigger the onboarding after login,
   * all of this avoiding loosing other query params like utms
   */
  if (url === '/entrar/' && nextUrl.includes('registro-extra')) {
    var qs = parseQueryStrings(window.location.search);
    if (qs) {
      delete qs.next;
      var search = Object.keys(qs).reduce(function (acc, key) {
        return "".concat(acc).concat(acc ? '&' : '').concat(key, "=").concat(qs[key]);
      }, '');
      window.location.href = "".concat(url).concat(search ? "?".concat(search) : '');
      return;
    }
  }
  window.location.href = "".concat(url).concat(queryParams);
};
export var sendRegisterTrackToGoogleAdsAndAnalytics = function sendRegisterTrackToGoogleAdsAndAnalytics() {
  // Google tag manager
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-769894422/7wKWCJ_UkNwBEJbQju8C'
    });
    window.gtag('event', 'Registro', {
      event_category: 'Registro',
      event_label: 'Registro Usuario',
      send_to: 'UA-60829200-1'
    });
  }
};
export var inIframe = function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
// extracted/copied from django project: crehana\frontdev\jsx\MainMenu\components\Right\ShoppingCart\FloatingShoppingCartReminder.tsx
export var setRecentlyLoggedStatus = function setRecentlyLoggedStatus() {
  customLocalStorage.setItem('CREHANA__USER_JUST_LOGGED', addMinutes(new Date(), 2).toString());
};

// extracted/copied from django project: crehana\frontdev\jsx\MainMenu\components\Right\ShoppingCart\FloatingShoppingCartReminder.tsx
var FLOATING_SHOPPING_CART_REMINDER_KEY = 'CREHANA__FloatingShoppingCartReminderVisibility';

// extracted/copied from django project: crehana\frontdev\jsx\MainMenu\components\Right\ShoppingCart\FloatingShoppingCartReminder.tsx
export var allowFloatingShoppingCartReminderVisibility = function allowFloatingShoppingCartReminderVisibility() {
  customLocalStorage.removeItem(FLOATING_SHOPPING_CART_REMINDER_KEY);
};